<template>
    <div class="grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5 pb-3">
        <h6 class="px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray">Denominazione</h6>
        <div class="flex flex-col mb-3">
            <Field field_name="Denominazione"
                   :model-value="denominazione"
                   :input-attrs="{disabled:disabled}"
                   @update:modelValue="$emit('update:denominazione', $event)"
                   :required="!denominazione && !disabled"
                   :errors="getErrors('denominazione')"></Field>
        </div>

        <div class="flex flex-col mb-3">
            <Field field_name="Sito web"
                   :model-value="sito"
                   @update:modelValue="$emit('update:sito', $event)"
                   :required="(!anagrafica_denominazione_id || anagrafica_denominazione_id == -1) && !disabled && !sito"
                   :input-attrs="{disabled:disabled}"
                   :errors="getErrors('sito')"></Field>
        </div>

        <div class="flex flex-col mb-3">
            <Field field_name="Gruppo di appartenenza"
                   :model-value="gruppo_di_appartenenza"
                   @update:modelValue="$emit('update:gruppo_di_appartenenza', $event)"
                   :input-attrs="{disabled:disabled}"
                   :errors="getErrors('gruppo_di_appartenenza')">
            </Field>
        </div>

        <div class="col-span-3">
            <MapViewer
                :placeId="place_id"
                :lat="lat"
                :lng="lng"
                :readonly="disabled"
                @update:placeId="$emit('update:place_id', $event)"
                @update:lat="$emit('update:lat', $event)"
                @update:lng="$emit('update:lng', $event)"
                @addressInformationChange="onAddressInformationChange">

                <template v-slot:actual="{actual}">
                    <p class="whitespace-nowrap">Selezione attuale: <b>{{
                            actual?.formatted_address || '----'
                        }}</b></p>
                </template>
            </MapViewer>
        </div>

        <slot v-if="!disabled">

        </slot>

        <div class="grid grid-cols-8 gap-3 mb-3">
            <div class="col-span-6 flex flex-col">
                <Field field_name="Sede operativa via"
                       :model-value="sede_operativa_via"
                       @update:modelValue="$emit('update:sede_operativa_via', $event)"
                       :input-attrs="{disabled:disabled}"
                       :errors="getErrors('sede_operativa_via')" placeholder="Nome via"></Field>
            </div>
            <div class="col-span-2 flex flex-col">
                <Field field_name="numero"
                       :model-value="sede_operativa_numero"
                       @update:modelValue="$emit('update:sede_operativa_numero', $event)"
                       :input-attrs="{disabled:disabled}"
                       :errors="getErrors('sede_operativa_numero')" placeholder="00"></Field>
            </div>
        </div>

        <div class="flex flex-col mb-3">
            <Field field_name="Sede operativa nazione"
                   :errors="getErrors('sede_operativa_nazione_id')">
                <VueMultiselect
                    :disabled="disabled"
                    v-model="so.na_selection"
                    :options="so.na_options"
                    placeholder="Nazione"
                    class="next-vue-multiselect-single"
                    track-by="id"
                    label="codice"
                    selectLabel=""
                    deselectLabel=""
                    selectedLabel=""
                    :internal-search="false"
                    @search-change="so.na_search"
                >
                    <template v-slot:option="{option}">{{ option.codice }} - {{ option.nome }}</template>
                </VueMultiselect>
            </Field>
        </div>

        <div class="flex flex-col mb-3">
            <Field field_name="Sede operativa cap"
                   :model-value="sede_operativa_cap"
                   @update:modelValue="$emit('update:sede_operativa_cap', $event)"
                   :input-attrs="{disabled:disabled}"
                   :errors="getErrors('sede_operativa_cap')" placeholder="CAP"></Field>
        </div>

        <div v-show="so.isNazioneItalia" class="flex flex-col mb-3">
            <Field :required="false" field_name="Sede operativa provincia"
                   :errors="getErrors('sede_operativa_provincia_id')">
                <VueMultiselect
                    :disabled="disabled"
                    v-model="so.pa_selection"
                    :options="so.pa_options"
                    placeholder="Prov."
                    class="next-vue-multiselect-single"
                    track-by="id"
                    label="codice"
                    selectLabel=""
                    deselectLabel=""
                    selectedLabel=""
                    :internal-search="false"
                    @search-change="so.pa_search"
                >
                </VueMultiselect>
            </Field>
        </div>
        <div v-show="so.isNazioneItalia" class="flex flex-col mb-3">
            <Field :errors="getErrors('sede_operativa_comune_id')" field_name="Sede operativa comune">
                <VueMultiselect
                    :disabled="disabled"
                    v-model="so.ca_selection"
                    :options="so.ca_options"
                    @tag="(value)=>so.ca_add({id:-1, nome:value})"
                    placeholder="Comune"
                    class="next-vue-multiselect-single"
                    track-by="id"
                    label="nome"
                    selectLabel=""
                    deselectLabel=""
                    selectedLabel=""
                    :internal-search="false"
                    @search-change="so.ca_search"
                >
                </VueMultiselect>
            </Field>
        </div>

        <div v-show="!so.isNazioneItalia" class="flex flex-col mb-3">
            <Field field_name="Sede operativa regione estera"
                   :model-value="sede_operativa_regione_estero"
                   @update:modelValue="$emit('update:sede_operativa_regione_estero', $event)"
                   :input-attrs="{disabled:disabled}"
                   :errors="getErrors('sede_operativa_regione_estero')" placeholder="Regione estera"></Field>
        </div>

        <div v-show="!so.isNazioneItalia" class="flex flex-col mb-3">
            <Field field_name="Sede operativa città estera"
                   :model-value="sede_operativa_citta_estero"
                   @update:modelValue="$emit('update:sede_operativa_citta_estero', $event)"
                   :input-attrs="{disabled:disabled}"
                   :errors="getErrors('sede_operativa_citta_estero')" placeholder="Città estera"></Field>
        </div>

        <div class="col-start-1 flex flex-col mb-3">
            <Field field_name="Email"
                   type="email"
                   :model-value="email"
                   @update:modelValue="$emit('update:email', $event)"
                   :input-attrs="{disabled:disabled}"
                   :errors="getErrors('email')" placeholder="Email"></Field>
        </div>
        <div class="flex flex-col mb-3">
            <Field field_name="Email pec"
                   type="email"
                   :model-value="pec"
                   @update:modelValue="$emit('update:pec', $event)"
                   :input-attrs="{disabled:disabled}"
                   :errors="getErrors('pec')" placeholder="Email pec"></Field>
        </div>

        <div class="flex flex-col mb-3">
            <Field field_name="Telefono 1"
                   :model-value="telefono_1"
                   @update:modelValue="$emit('update:telefono_1', $event)"
                   :input-attrs="{disabled:disabled}"
                   :errors="getErrors('telefono_1')" placeholder="Telefono"></Field>
        </div>
        <div class="flex flex-col mb-3">
            <Field field_name="Telefono 2"
                   :model-value="telefono_2"
                   @update:modelValue="$emit('update:telefono_2', $event)"
                   :input-attrs="{disabled:disabled}"
                   :errors="getErrors('telefono_2')" placeholder="Telefono"></Field>
        </div>
        <div class="flex flex-col mb-3">
            <Field field_name="Fax"
                   :model-value="fax"
                   @update:modelValue="$emit('update:fax', $event)"
                   :input-attrs="{disabled:disabled}"
                   :errors="getErrors('fax')" placeholder="Fax"></Field>
        </div>
    </div>

</template>
<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import MapViewer from "@/components/Address/MapViewer.vue";
import Field from "@/components/Field.vue";
import {Watch} from "vue-property-decorator/lib/decorators/Watch";
import {ProvinciaComune} from "@/setup/ProvinciaComuneAutocomplete";
import NextButton from "@/components/NextButton.vue";
import anagraficheManager from "@/api/Denominazioni";


@Options({
    name: 'AnagraficaDenominazione',
    components: {
        Field,
        MapViewer,
        NextButton
    },
    props: {
        anagrafica_denominazione_id: [Number,String],
        denominazione: String,
        sito: String,
        gruppo_di_appartenenza: String,
        place_id: String,
        lat: [Number, String],
        lng: [Number, String],
        sede_operativa_via: String,
        sede_operativa_numero: String,
        sede_operativa_nazione_id: Number,
        sede_operativa_cap: String,
        sede_operativa_regione_estero: String,
        sede_operativa_citta_estero: String,
        sede_operativa_provincia_id: Number,
        sede_operativa_comune_id: Number,
        email: String,
        pec: String,
        telefono_1: String,
        telefono_2: String,
        fax: String,
        errors: {
            type: Object,
            required: false,
            default: () => ({})
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
    }

})
export default class AnagraficaDenominazione extends Vue {
    errors!: any

    so = setup(() => {
        return ProvinciaComune()
    })

    onAddressInformationChange(address: any) {
        this.so.disableProvinciaWatcher = true
        this.so.na_search(address.country).then(() => {
            this.so.na_selection = this.so.na_options.find((e: any) => e.nome.toLowerCase() == address?.country?.toLowerCase())
            return this.so.pa_search(address?.province)
        }).then(() => {
            this.so.pa_selection = this.so.pa_options.find((e: any) => e.codice.toLowerCase() == address?.province?.toLowerCase())
            return this.so.ca_search(address?.locality)
        }).then(() => {
            this.so.ca_selection = this.so.ca_options.find((e: any) => e.nome.toLowerCase() == address?.locality?.toLowerCase())
        }).finally(() => {
            this.so.disableProvinciaWatcher = false
        })

        this.$emit('update:sede_operativa_via', address.route)
        this.$emit('update:sede_operativa_numero', address.street_number)
        this.$emit('update:sede_operativa_cap', address.postal_code)
        this.$emit('update:sede_operativa_regione_estero', address.region)
        this.$emit('update:sede_operativa_citta_estero', address.locality)
    }

    @Watch('anagrafica_denominazione_id')
    anagraficaDenominazioneIdWatch(anagrafica_denominazione_id: any, old: any) {
        anagraficheManager.anagrafica(anagrafica_denominazione_id).then((res: any) => {
            res = res.data
            this.$emit('update:denominazione', res.denominazione)
            this.$emit('update:sito', res.sito)
            this.$emit('update:gruppo_di_appartenenza', res.gruppo_di_appartenenza)

            this.$emit('update:place_id', res.place_id)
            this.$emit('update:lat', res.lat)
            this.$emit('update:lng', res.lng)

            this.$emit('update:sede_operativa_via', res.sede_operativa_via)
            this.$emit('update:sede_operativa_numero', res.sede_operativa_numero)
            this.$emit('update:sede_operativa_cap', res.sede_operativa_cap)
            this.$emit('update:sede_operativa_regione_estero', res.sede_operativa_regione_estero)
            this.$emit('update:sede_operativa_citta_estero', res.sede_operativa_citta_estero)

            this.$emit('update:sede_operativa_provincia_id', res.sede_operativa_provincia_id)
            this.$emit('update:sede_operativa_nazione_id', res.sede_operativa_nazione_id)
            this.$emit('update:sede_operativa_comune_id', res.sede_operativa_comune_id)
            this.$emit('update:email', res.email)
            this.$emit('update:pev', res.pec)
            this.$emit('update:telefono_1', res.telefono_1)
            this.$emit('update:telefono_2', res.telefono_2)
            this.$emit('update:fax', res.fax)
        })

    }

    @Watch('sede_operativa_nazione_id')
    sedeOperativaNazioneIdWatch(sede_operativa_nazione_id: any, old: any) {
        this.so.na_retrieve(sede_operativa_nazione_id)
    }

    @Watch('sede_operativa_provincia_id')
    sedeOperativaProvinciaIdWatch(sede_operativa_provincia_id: any, old: any) {
        this.so.pa_retrieve(sede_operativa_provincia_id)
    }

    @Watch('sede_operativa_comune_id')
    sedeOperativaComuneIdWatch(sede_operativa_comune_id: any, old: any) {
        this.so.ca_retrieve(sede_operativa_comune_id)
    }

    @Watch('so.pa_selection')
    sede_operativa_provincia(new_value: any, old: any) {
        this.$emit('update:sede_operativa_provincia_id', new_value?.id || new_value)
    }

    @Watch('so.na_selection')
    sede_operativa_nazione(new_value: any, old: any) {
        this.$emit('update:sede_operativa_nazione_id', new_value?.id || new_value)
    }

    @Watch('so.ca_selection')
    sede_operativa_comune(new_value: any, old: any) {
        this.$emit('update:sede_operativa_comune_id', new_value?.id || new_value)
    }

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

}
</script>


<style lang="scss">

</style>
